import { UIIcon } from '../config/icons';
import { ABFilter, ABFilterBar } from '../lib/ab/filter-bar';
import { ABObjectCount } from '../lib/ab/widgets-admin';
import { c_cities } from '../lib/mdl/c-city';
import { CSessionUpcomingView, CEventAdminView, CSession, cSessionUpdate, CEventAdminListView, cSessionFullTime, cEventAdminViewGet, cEventActiveSessions, cSessionSalesEnd, CSessionUpcomingViewEvent, cEventDelete, cEventsAdminListQuery, cReviewsAdminView, cEventCanDelete, CReviewAdminView, cReviewHide, cSessionsGetUpcoming } from '../lib/mdl/c-event-admin';
import { c_producers } from '../lib/mdl/c-producer';
import { c_venues } from '../lib/mdl/c-venue';
import { the_alt_token } from '../lib/me/login';
import { uiSetBG } from '../lib/ui/bg';
import { UIButton, makeActionButton } from '../lib/ui/component/button';
import { UIDialog } from '../lib/ui/component/dialog';
import { UINumberInput } from '../lib/ui/component/input';
import { UILabeled } from '../lib/ui/component/labeled';
import { UITableRow, UITableDefinition, UITable } from '../lib/ui/component/table';
import { uiToast } from '../lib/ui/component/toast';
import { addTooltip } from '../lib/ui/component/tooltip';
import { showWarning } from '../lib/ui/component/warning';
import { $el } from '../lib/ui/elements';
import { $fmt } from '../lib/ui/fmt';
import { UIScreen } from '../lib/ui/screen';
import { UIRelPos } from '../lib/ui/types';
import { UIViewSpec } from '../lib/ui/view';
import { QByFilter, YArrayDataSource, YQueryDataSource } from '../lib/y/data-source';
import { $log, xavis_experiments } from '../lib/y/debug';
import { $fn } from '../lib/y/fn';
import { yGetI18N } from '../lib/y/i18n';
import { $location } from '../lib/y/location';
import { YDate, YTime, $time } from '../lib/y/time';
import { YId } from '../lib/y/types';

function getEventQueryFilter(filters: ABFilter[], search: string) {
    const filter: QByFilter = { by: {} };
    let from: YDate | undefined;
    let to: YDate | undefined;

    for(const f of filters) {
        if(f.key == 'city')
            filter.by.city_id = { in: f.value.map((s: YId) => ({ id: s })) };
        else if(f.key == 'producer')
            filter.by.producer_id = { in: f.value.map((s: YId) => ({ id: s })) };
        else if(f.key == 'venue')
            filter.by.venue_id = { in: f.value.map((s: YId) => ({ id: s })) };
        else if(f.key == 'genre')
            filter.by.event_tag_id = { in: f.value.map((s: YId) => ({ id: s })) };
        else if(f.key == 'from_date')
            from = f.value;
        else if(f.key == 'to_date')
            to = f.value;
        else if(f.key == 'unpublished')
            filter.by.is_published = { eq: { bool: false } };
    }

    if(from || to) {
        filter.by.session_time = { gt: from && { date: from }, lt: to && { date: to } };
    }

    search = search.trim();
    if(search.length) {
        filter.by.search = { eq: { str: search } };
    }

    return filter;
}

function filterSessions(sessions: CSessionUpcomingView[], filters: ABFilter[]) {
    let from: YTime | undefined;
    let to: YTime | undefined;

    for(const f of filters) {
        switch(f.key) {
            case 'city': sessions = sessions.filter(s => f.value.includes(s.event.city_id)); break;
            case 'producer': sessions = sessions.filter(s => f.value.includes(s.event.producer_id)); break;
            case 'venue': sessions = sessions.filter(s => f.value.includes(s.event.venue_id)); break;
            case 'genre': sessions = sessions.filter(s => f.value.some((v: YId) => s.event.event_tag_ids.includes(v as YId))); break;
            case 'from_date': from = f.value.start; break;
            case 'to_date': to = f.value.end; break;
        }
    }

    if(from || to)
        sessions = sessions.filter(s => $time(s.time).inRange(from, to));

    return sessions;
}

class AddTicketsDialog extends UIDialog {
    constructor(event: CEventAdminView, session: CSession) {
        super({ close: true, classes: 'm-500' });

        const amount = new UINumberInput({ required: true });

        amount.value = session.quantity;

        this.content.ui_add($el.DIV('w-block l-form m-center', [
            $el.H2('title', yGetI18N(event.name)),
            $el.H3('heading', $time(session.time).format('yyyy-MM-dd HH:mm')),
            new UILabeled($el.B('' + session.quantity), { above: 'Current amount' }),
            new UILabeled(amount, { above: 'New amount' }),
            $el.DIV('l-button-row', [
                new UIButton({ title: "Cancel", classes: 'm-round m-compact', on_click: () => { this.dismiss(null) } }),
                new UIButton({
                    title: "Update", classes: 'm-round m-compact m-hollow', on_click: () => {
                        const value = amount.value || 0;
                        return cSessionUpdate(event, session.id, { quantity: value }).then(() => {
                            session.quantity = value;
                            this.dismiss(true);
                        }, uiToast)
                    }
                })
            ]),
        ]));
    }
}

function listScreenRowController(row: UITableRow<CEventAdminListView>) {
    return {
        expand: () => {
            const event_admin = row.item;
            let event: CEventAdminView;

            const def = new UITableDefinition<CSession>();
            def.addValue(s => cSessionFullTime(s), { width: 260, sort: false });
            def.addCustom({
                width: 80, decorator: (td, row) => {
                    const s = row.item;
                    if(s.quantity_booked != s.quantity_reserved) {
                        const span = $el.SPAN('r-has-tooltip', s.quantity_reserved + '');
                        addTooltip(s.quantity_booked + ' booked + ' + (s.quantity_reserved - s.quantity_booked) + ' reservations', row,
                            { anchor: span, hover: td, position: UIRelPos.Above, offset: 5 });
                        td.ui_add([span, ' / ' + s.quantity]);
                    } else {
                        td.ui_add(s.quantity_reserved + ' / ' + s.quantity);
                    }
                }
            });
            def.addValue(s => s.quantity_standby ? '(+' + s.quantity_standby + ')' : '', { width: 60, sort: false });
            def.addButtons([
                {
                    icon: UIIcon.EYE, tooltip: 'View', action: item => {
                        $location.push('event_bookings', { session_id: item.id });
                    }
                },
                {
                    icon: UIIcon.CIRCLE_PLUS, tooltip: 'Add tickets', action: (item, r) => {
                        new AddTicketsDialog(event, item).present().then(() => { r.reload(); row.reload() });
                    }
                }
            ], { width: -62 });

            const source = new YArrayDataSource<CSession>();

            cEventAdminViewGet(event_admin.id).then(e => {
                event = e;
                source.data = cEventActiveSessions(e);
            })

            return $el.DIV('tl-inner-table', new UITable(def, source));
        }
    }
}

export class AdminEventsScreen extends UIScreen {
    protected override fillContent(content: UIViewSpec): void {
        const doSearch = () => {
            source.filter = getEventQueryFilter(filter_bar.filters.filters, filter_bar.search_input!.value);
        }

        const excel_download = new UIButton({ kind: 'k-filter', icon: UIIcon.DOWNLOAD, title: 'Excel', link: `/docs/events_excel?token=${the_alt_token}` });
        const count = new ABObjectCount('events');

        const filter_bar = new ABFilterBar({
            on_search: $fn.debounce(doSearch, 0.3),
            on_filter: doSearch,
            right_content: [excel_download, count],
            no_header: true
        });

        const filters = filter_bar.filters;
        filters.addFilterButton();
        filters.addCity();
        filters.addProducer();
        filters.addVenue();
        filters.addGenre();
        filters.addFromDate();
        filters.addToDate();
        filters.addUnpublished();

        const def = new UITableDefinition<CEventAdminListView>();
        def.addCustom({
            width: -50, classes: 'tl-thumb-cell', decorator: (td, row) => {
                const event = row.item;
                const image = $el.DIV('r-image');
                uiSetBG(image, { media: event.picture_ids[0], variant: 'size-500' });
                td.appendChild(image);
                td.appendChild($el.DIV('r-indicator ' + (event.is_published ? 'r-green' : (!!event.next_session || event.has_videos) ? 'r-yellow' : 'r-red')));
            }
        });

        def.addValue(e => yGetI18N(e.name), { id: 'name', title: 'Name', width: 200 });
        def.addValue(e => c_cities.maybe(e.city_id)!.name, { id: 'city', title: 'City', width: -120, optional: true });
        def.addValue(e => c_venues.maybe(e.venue_id)?.name || '-', { id: 'venue', title: 'Venue', width: 100, optional: true });
        def.addValue(e => c_producers.maybe(e.producer_id)?.name || '-', { id: 'producer', title: 'Producer', width: 100, optional: true });
        def.addValue(e => e.added_by_name, { id: 'added_by', title: 'Added by', width: 100, optional: true });
        def.addValue(e => $time(e.created_at), $fmt.DATE('d MMM yyyy'), { id: 'created_at', title: 'Added at', width: -120, optional: true });
        def.addValue(e => $time(e.published_at), $fmt.DATE('d MMM yyyy'), { id: 'published_at', title: 'Published at', width: -120, optional: true });
        def.addValue(e => $time(e.next_session), $fmt.DATE('d MMM yyyy HH:mm'), { id: 'next_session', title: 'Next session', width: -150, optional: true });
        def.addCustom({
            id: 'quantity', title: 'Bookings', width: -100, decorator: (td, row) => {
                const stats = row.item.statistics;
                td.ui_add(stats.quantity_booked + ' / ' + stats.quantity);
            }, optional: true
        });
        def.addCustom({
            id: 'rating', title: 'Rating', width: -75, decorator: (td, row) => {
                const item = row.item;
                const up = item.statistics.ratings_up;
                const down = item.statistics.ratings_down;

                if(up + down > 0) {
                    const span = $el.I(`${(up / (up + down) * 100).toFixed(0)}%`);
                    addTooltip(`${up} up / ${down} down`, row, { anchor: span, hover: td, position: UIRelPos.Above, offset: 5 });
                    td.ui_add(span);
                } else {
                    td.ui_add('-');
                }
            }, optional: true
        });
        def.addValue(e => e.statistics.opens || 0, $fmt.NUMBER, { id: 'opens', title: 'Opens', width: -90, optional: true });
        if(xavis_experiments)
            def.addValue(e => !!e.imported_id, $fmt.CHECKMARK, { id: 'imported', title: 'Imported', width: -80, optional: true });

        def.addButtons([
            {
                icon: UIIcon.TRASH_CAN, tooltip: 'Delete', when: item => cEventCanDelete(item), action: item => {
                    return showWarning({ text: "Are you sure you want to delete this event?" }).then(() => {
                        return cEventDelete(item.id).then(() => { source.reload() });
                    });
                }
            },
            {
                icon: UIIcon.COPY, tooltip: 'Duplicate', action: item => {
                    $location.push('event', { event_id: item.id, duplicate: true })
                }
            },
            {
                icon: UIIcon.PENCIL, tooltip: 'Edit', action: item => {
                    $location.push('event', { event_id: item.id })
                }
            },
            { icon: UIIcon.EYE, tooltip: 'View', link: item => `https://abundolive.se/event/${c_cities.maybe(item.city_id)!.slug}/${item.slug}` }
        ], { width: -125 });

        def.controller = listScreenRowController;
        def.preference_prefix = 'events';

        const source = new YQueryDataSource(params => cEventsAdminListQuery(params).then(response => {
            if(response.count) {
                if(response.count == 1001)
                    count.text = '1000+';
                else
                    count.number = response.count;
            }
            return response;
        }));

        const table = new UITable(def, source);

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block m-widest', [
                filter_bar,
                table,
            ])),
            makeActionButton(UIIcon.PLUS, 'Create new', () => { $location.push('event') })
        ]);

        table.on_row_selected = (r) => {
            $log('app', r.item.id);
            r.expand(true);
        }

        this.onViewDidReappear = () => { source.refresh() };
    }
}

export class AdminReviewsScreen extends UIScreen {
    protected override async fillContent(content: UIViewSpec) {
        const all_reviews = await cReviewsAdminView();

        const doSearch = () => {
            let reviews = all_reviews
            let pdf_link: string | undefined;

            for(const f of filters.filters) {
                switch(f.key) {
                    case 'city': reviews = reviews.filter(r => f.value.includes(r.city_id)); break;
                    case 'producer':
                        reviews = reviews.filter(r => f.value.includes(r.producer_id));
                        pdf_link = '/docs/reviews?token=' + the_alt_token + '&producer=' + f.value[0];
                        break;
                }
            }

            if(pdf_link) {
                pdf_download.ui_show();
                pdf_download.link = pdf_link;
            } else {
                pdf_download.ui_hide();
            }

            reviews = filter_bar.search_input!.filterArray(reviews, (r, w) => {
                if(r.event_name.toLowerCase().includes(w)) return true;
                if(r.user_name.toLowerCase().includes(w)) return true;
                return false;
            });

            let up = 0;
            for(const r of reviews) {
                if(r.rating == 'up')
                    up++;
            }
            positive.textContent = reviews.length ? ('\u00a0\u00a0(' + (100 * up / reviews.length).toFixed(0) + '% up)') : '';
            count.number = reviews.length;
            source.data = reviews;
        }

        const pdf_download = new UIButton({ kind: 'k-filter', icon: UIIcon.DOWNLOAD, title: 'PDF', link: '' });
        pdf_download.ui_hide();

        const count = new ABObjectCount('reviews');
        const positive = $el.SPAN()
        const filter_bar = new ABFilterBar({
            on_search: doSearch,
            on_filter: doSearch,
            right_content: [pdf_download, count, positive],
            no_header: true
        });

        const filters = filter_bar.filters;
        filters.addFilterButton();
        filters.addCity();
        filters.addProducer();

        const doHide = (item: CReviewAdminView, row: UITableRow<CReviewAdminView>) => {
            cReviewHide(item.id).then(r => {
                item.is_hidden = r;
                row.reload();
            });
        }

        const def = new UITableDefinition<CReviewAdminView>();
        def.addValue(e => e.user_name, { title: 'User', width: 80 });
        def.addValue(e => e.event_name, { title: 'Event', width: 100 });
        def.addValue(e => $time(e.session_time), $fmt.DATE('yyyy-MM-dd HH:mm'), { title: 'Session', width: -140 });
        def.addValue(e => $time(e.created_at), $fmt.DATE(), { title: 'Date', width: -100 });
        def.addValue(e => e.rating, { title: 'Rating', width: -100 });
        def.addValue(e => e.text, { title: 'Review', width: 240 });
        def.addButtons([
            { icon: UIIcon.TRASH_CAN, tooltip: 'Remove', action: doHide, when: r => !r.is_hidden },
            { icon: UIIcon.ROTATE, tooltip: 'Restore', action: doHide, when: r => r.is_hidden }
        ], { width: -62 });

        def.preference_prefix = 'reviews';

        const source = new YArrayDataSource<CReviewAdminView>();

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block m-wide', [
                filter_bar,
                new UITable(def, source),
            ]))
        ]);

        doSearch();
    }
}

export class AdminUpcomingScreen extends UIScreen {
    protected override async fillContent(content: UIViewSpec) {
        const doSearch = () => {
            let sessions = all_sessions;
            sessions = filterSessions(sessions, filters.filters);
            if(!filters.value.show_sent)
                sessions = sessions.filter(s => !s.tickets_sent);

            sessions = filter_bar.search_input!.filterArray(sessions, (s, w) => {
                if(yGetI18N(s.event.name).toLowerCase().includes(w)) return true;
                return false;
            });

            count.number = sessions.length;
            source.data = sessions;
        }

        const count = new ABObjectCount('sessions');

        const filter_bar = new ABFilterBar({
            on_search: $fn.debounce(doSearch, 0.3),
            on_filter: doSearch,
            right_content: [count],
            no_header: true
        });

        const filters = filter_bar.filters;
        filters.addFilterButton();
        filters.addCity();
        filters.addProducer();
        filters.addVenue();
        filters.addGenre();
        filters.addFromDate();
        filters.addToDate();
        filters.addCheckbox('show_sent', 'Show sent');
        filters.addCheckbox('include_integrations', 'Include integrations');

        const def = new UITableDefinition<CSessionUpcomingView>();
        def.addCustom({
            width: -32, classes: 'tl-thumb-cell', decorator: (td, row) => {
                const item = row.item;
                const image = $el.DIV('r-image');
                uiSetBG(image, { media: item.event.picture_ids[0], variant: 'size-500' });
                td.appendChild(image);
            }
        });

        def.addValue(i => yGetI18N(i.event.name), { title: 'Name', width: 200 });
        def.addValue(i => $time(i.time), $fmt.DATE('MMM dd HH:mm'), { title: 'Time', width: -130 });
        def.addValue(i => i.quantity_booked, $fmt.NUMBER, { title: 'Tickets', width: -90 });
        def.addValue(i => cSessionSalesEnd(i), $fmt.DATE('MMM dd HH:mm'), { title: 'Sales end', width: -130 });
        def.addValue(i => i.tickets_sent, $fmt.CHECKMARK, { title: 'Sent', width: -80 });

        def.addButtons([
            {
                icon: UIIcon.LIST_UL, tooltip: 'Booking list', action: item => {
                    $location.push('event_bookings', { session_id: item.id });
                }
            },
        ], { width: -31 });
        def.preference_prefix = 'upcoming';

        const source = new YArrayDataSource<CSessionUpcomingView>();
        const table = new UITable(def, source);

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block m-narrow', [
                filter_bar,
                table,
            ])),
        ]);

        const all_sessions = (await cSessionsGetUpcoming(true)).filter(s => s.ticket_type == 'email');
        doSearch();
    }
}

interface EventOccupancy {
    event: CSessionUpcomingViewEvent;
    sessions: number;
    available: number;
    booked: number;
}

export class AdminOccupancyScreen extends UIScreen {
    protected override async fillContent(content: UIViewSpec) {
        const doSearch = () => {
            let sessions = all_sessions;
            sessions = filterSessions(sessions, filters.filters);

            const now = $time.now();
            const now_14 = now.add(14, $time.day);
            const all = filters.value.show_all;

            if(!all)
                sessions = sessions.filter(s => $time(s.time).before(now_14));

            const grouped: EventOccupancy[] = Object.entries(Object.groupBy(sessions, s => s.event.id)).map(e => {
                let num_sessions = 0;
                let num_available = 0;
                let num_booked = 0;

                for(const s of e[1]!) {
                    num_sessions++;
                    num_available += s.quantity;
                    num_booked += s.quantity_booked;
                }

                return {
                    event: e[1]![0].event,
                    sessions: num_sessions,
                    available: num_available,
                    booked: num_booked
                };
            });

            count.number = grouped.length;
            source.data = grouped;
        }

        const count = new ABObjectCount('sessions');

        const filter_bar = new ABFilterBar({
            on_filter: doSearch,
            right_content: [count],
            no_header: true
        });

        const filters = filter_bar.filters;
        filters.addFilterButton();
        filters.addCity();
        filters.addProducer();
        filters.addGenre();
        filters.addCheckbox('show_all', 'Show all');

        const def = new UITableDefinition<EventOccupancy>();
        def.addCustom({
            width: -32, classes: 'tl-thumb-cell', decorator: (td, row) => {
                const image = $el.DIV('r-image');
                uiSetBG(image, { media: row.item.event.picture_ids?.[0], variant: 'size-500' });
                td.appendChild(image);
            }
        });

        def.addValue(o => yGetI18N(o.event.name), { title: 'Event name', width: 200 });
        def.addValue(o => o.sessions, $fmt.NUMBER, { title: 'Sessions', width: -110 });
        def.addValue(o => o.available, $fmt.NUMBER, { title: 'Available', width: -110 });
        def.addValue(o => o.booked, $fmt.NUMBER, { title: 'Booked', width: -110 });
        def.addValue(o => o.available ? o.booked / o.available : 0, $fmt.PERCENTAGE, { title: 'Occupancy', width: -110 });
        def.preference_prefix = 'occupancy';

        const source = new YArrayDataSource<EventOccupancy>();
        const table = new UITable(def, source);

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block', [
                filter_bar,
                table,
            ])),
        ]);

        const all_sessions = await cSessionsGetUpcoming(true);
        doSearch();
    }
}
